import React from "react"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import classes from "./ApprovePaymentModalCard.module.scss"

const ApprovePaymentModalCard = props => {
  const {
    cIndex,
    cashType,
    focusedCashType,
    setFocusedCashType
  } = props

  return (
    <div
      onClick={() => setFocusedCashType(cIndex)}
      className={clsx(
        classes["card"],
        focusedCashType === cIndex && classes["active"]
      )}
    >
      <div className={classes["name"]}>
        {cashType.name}
      </div>

      <div className={classes["row"]}>
        <div className={classes["amount"]}>
          {thousandSeparator(cashType.amount)}
        </div>
      </div>
    </div>
  )
}

export default React.memo(ApprovePaymentModalCard)